import React, { useEffect } from 'react';

import { Grid } from '@mui/material';
import CreateCarrierForm, { initCreateCarrier } from './Form';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../../store';
import { createCarrier, getCarrierById } from '../../../../store/reducers/Carrier';
import { useFormik } from 'formik';
import SbButton from '../../../../components/Button';
import { CreateCarrierPayload } from '@Reducers/Carrier/Type';
import { CreateCarrierSchema } from './schema';
import { useNavigate, useParams } from 'react-router-dom';
import { RootStateType } from '../../../../store/index';
import { updateCarrierById } from '../../../../store/reducers/Carrier';

function CreateCarrier() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const carrierId = useParams().id;
  const singleCarrier = useSelector((state: RootStateType) => state.carrier.singleCarrier);

  const onCreate = (params: CreateCarrierPayload) => {
    // Filter out empty objects from vendorLocationMap
    const filteredVendorLocationMap = (params.vendorLocationMap || [])
      .filter(item => {
        // Check if both fields are non-empty
        const hasName = item.name && item.name.trim() !== '';
        const hasLocationId = item.locationId && item.locationId.trim() !== '';

        // Keep only items where BOTH fields are filled
        return hasName && hasLocationId;
      })
      .map(item => ({
        name: item.name.trim(),
        locationId: item.locationId.trim(),
      }));

    const payload = {
      name: params.name,
      code: params.code,
      logo: params.logo,
      isAccountHolder: params.isAccountHolder,
      api_key: params.api_key,
      secret_key: params.secret_key,
      _system: params._system,
      accountNo: params.accountNo,
      pin: params.pin,
      entity: params.entity,
      d365AccountDisplayValue: params.d365AccountDisplayValue || '',
      vendorLocationMap: filteredVendorLocationMap,
    };

    if (carrierId) {
      dispatch(updateCarrierById([carrierId, payload]));
    } else {
      dispatch(createCarrier(payload));
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: carrierId && singleCarrier ? singleCarrier : initCreateCarrier,
    validationSchema: CreateCarrierSchema,
    onSubmit(values) {
      onCreate(values);
    },
  });

  const onCancel = () => {
    navigate('/carrier-and-services?tab=carrier');
  };

  useEffect(() => {
    const fetchCarrier = async () => {
      if (carrierId) {
        await dispatch(getCarrierById(carrierId));
      }
    };
    fetchCarrier();
  }, [carrierId]);

  return (
    <>
      <Grid container>
        <Grid item xs={12} className="p-4">
          <CreateCarrierForm
            formType={carrierId ? 'edit' : 'create'}
            errors={formik.errors}
            values={formik.values}
            handleChange={formik.handleChange}
            setFieldValue={formik.setFieldValue}
          />
        </Grid>
        <Grid container item mt={4} spacing={2} justifyContent="flex-end">
          <Grid item xs={6} sm={3} md={2} lg={1.5} xl={1}>
            <SbButton fullWidth variant="outlined" onClick={onCancel}>
              Cancel
            </SbButton>
          </Grid>
          <Grid item xs={6} sm={3} md={2} lg={1.5} xl={1}>
            <SbButton
              fullWidth
              variant="contained"
              onClick={_event => {
                formik.handleSubmit();
              }}
            >
              {carrierId ? 'Update' : 'Create'}
            </SbButton>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default CreateCarrier;
